import { render, staticRenderFns } from "./EventManagementWrapper.vue?vue&type=template&id=5474fa3e&scoped=true"
import script from "./EventManagementWrapper.vue?vue&type=script&lang=js"
export * from "./EventManagementWrapper.vue?vue&type=script&lang=js"
import style0 from "./EventManagementWrapper.vue?vue&type=style&index=0&id=5474fa3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5474fa3e",
  null
  
)

export default component.exports